var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BannerVideo',{attrs:{"video":_vm.video}}),_c('Details',{attrs:{"video":_vm.video}}),_c('div',{staticClass:"mt-4"}),_vm._l((_vm.categories),function(category,key){return _c('Items',{key:key,attrs:{"category":category,"categoryID":key}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }